import { ITypeFilter } from "../interfaces/i-type-filter";

export const TypeFilter = (
  title: any,
  value: any,
  type?: any,
  style?: any,
  description?: any,
  checked: boolean = true,
  cardExpanded?: boolean,
  match: number = 0,
  visible: number = 0,
  available: number = 0,
  available3D: number = 0,
): ITypeFilter => ({
  title,
  value,
  type,
  style,
  description,
  checked,
  cardExpanded,
  match,
  visible,
  available,
  available3D,
});
